import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { RouteValidationService } from '../authorization/route-validation.service';
import { TokenService } from '@morningstar/shared/auth';
import { SecurityGroupAuthorization } from './security-group-authorization';

@Injectable()
export class SecurityGroupGuardService implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router, private snackbar: MatSnackBar,
              private routeValidationService: RouteValidationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const authorizationLevel = route.data['authorizationLevel'];

    const securityGroup = this.tokenService.getSecurityGroup();

    let routePath = '';

    // Use routeConfig path property instead of URL to filter out URL parameters
    route.pathFromRoot.forEach(p => {
      if(p.routeConfig && p.routeConfig.path !== ''){
        let paths = p.routeConfig.path.split('/');
        paths.forEach(path => {
          if(path.indexOf(':') < 0){
            routePath += '/' + path;
          }
        })
      }
    })

    if ((SecurityGroupAuthorization.isUserAuthorized(securityGroup, authorizationLevel) &&
        this.routeValidationService.validateRoute(routePath)) ||
        this.routeValidationService.validateRoute(routePath)) {

      const msClients = route.data['msClients'];
      const currentMSClient = this.tokenService.getMSClient();

      if (msClients == null) {
        return true;
      }

      if (msClients != null && Array.from(msClients).includes(currentMSClient)) {
        return true;
      }
    }

    this.snackbar.open('Unauthorized', 'DISMISS', {
      duration: 2000
    });

    return false;
  }
}
